import PropTypes from 'prop-types';

export default {
  id: PropTypes.number,
  length: PropTypes.string,
  thumbnailSrc: PropTypes.string,
  videoSrc: PropTypes.string,
  title: PropTypes.string
};